import React, { Component } from 'react';
import { Cookies } from "react-cookie";
import redArrow from '../assets/red-arrow.png';
import blueArrow from '../assets/blue-arrow.png';
import '../styles/Vote.css';


export class ShowNotStarted extends Component {
    render() {
        return (
            <div>
                <h1>The game <br />has not yet <br />begun...</h1>
                <a href="https://weareoldred.co.uk/whats-on/grimfest/survive-the-night/" target="_self" rel="noopener noreferrer">
                    <button className="btn btn-primary btn-Buy"></button>
                </a>
            </div>
        )
    }
}

export class NoVote extends Component {
    render() {
        return (
            <div>
                <h1>Game in <br />progress...</h1>
            </div>
        )
    }
}

const userCookies = new Cookies();


export class VotingPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            CurrentVote: "NO",
            userID: userCookies.get('userID') || "NOT SET",
            userVote: "NOT SET"
        };
        this.setVote = this.setVote.bind(this);
    }

    getUserId() {
        if (this.state.userID === "NOT SET") {
            const newUserId = this.makeId(12);
            this.setState({
                userID: newUserId,
            });
            userCookies.set('userID', newUserId);
        }
        return this.state.userID;
    }

    makeId(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }

    setVote(button_clicked) {
        const vote_for = button_clicked.target.value
        const userVote = JSON.stringify({
            "pollId": this.props.activePollId,
            "userId": this.state.userID,
            "vote": vote_for
        });
        this.setState({
            CurrentVote: vote_for,
            userVote: userVote
        });
        fetch('api/Vote', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: userVote
        })
    }

    render() {
        return (
            <div>
                <p className='hidden' aria-live="polite">
                    Current Vote: <strong>{this.state.CurrentVote}</strong>,
                    User_ID = {this.getUserId()},
                    user_Vote = {this.state.userVote}
                </p>
                <h1 className="pt-10">What will you <br />do?</h1>
                <div className="row triangle-selectors">
                    <div className="voting-item_container"><img className={'arrow arrow-bob ' + (this.state.CurrentVote === "B" ? "hide" : "")} src={redArrow} alt="red arrow" /></div>
                    <div className="voting-item_container"><img className={'arrow arrow-bob ' + (this.state.CurrentVote === "A" ? "hide" : "")} src={blueArrow} alt="blue arrow" /></div>
                </div>
                <div className="row">
                    <div className="voting-item_container"><button className="btn-vote btn-A" value="A" onClick={this.setVote} alt="triangle"></button></div>
                    <div className="voting-item_container"><button className="btn-vote btn-B" value="B" onClick={this.setVote} alt="circle" ></button></div>
                </div>
            </div>
        );
    }
}


export class VotingNumberPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dialedNumber: [],
            userID: userCookies.get('userID') || "NOT SET",
            result: ""
        };
        this.addNumber = this.addNumber.bind(this);
    }

    getUserId() {
        if (this.state.userID === "NOT SET") {
            const newUserId = this.makeId(12);
            this.setState({
                userID: newUserId,
            });
            userCookies.set('userID', newUserId);
        }
        return this.state.userID;
    }

    makeId(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }

    addNumber(number_dialed) {
        if (this.state.result === "") {
            const number_entered = number_dialed.target.value;
            var new_state = [...this.state.dialedNumber, number_entered]
            this.setState({ dialedNumber: new_state });

            let len = new_state.length;
            document.getElementById("dig" + (len - 1)).innerText = number_entered;
            if (len === 10) {
                var numbersdialed = new_state.toString()
                if (numbersdialed === "0,1,5,0,3,2,0,6,6,6") {
                    this.setState({ result: "correct" });
                    this.send_result("B");
                }
                else {
                    this.setState({ result: "wrong" });
                    this.send_result("A");
                }
            }
        }
    }

    send_result(vote_for) {
        const userVote = JSON.stringify({
            "pollId": this.props.activePollId,
            "userId": this.state.userID,
            "vote": vote_for
        });

        fetch('api/Vote', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: userVote
        })
        return true;
    }

    render() {
        return (
            <div className="keypad-input_container">
                <p className='hidden' aria-live="polite">Current Vote: <strong>{this.state.CurrentVote}</strong>, User_ID = {this.getUserId()}, user_Vote = {this.state.userVote}</p>
                <h1 className="pt-10">Type the correct number?</h1>
                <p className={'numbers ' + (this.state.result)}>
                    <span id="dig0">_</span>
                    <span id="dig1">_</span>
                    <span id="dig2">_</span>
                    <span id="dig3">_</span>
                    <span id="dig4">_</span>
                    <span id="dig5">_</span>
                    <span id="dig6">_</span>
                    <span id="dig7">_</span>
                    <span id="dig8">_</span>
                    <span id="dig9">_</span>
                </p>
                <div className="keypad">
                    <div className="keypad_button"><button className="btn-number" value="7" onClick={this.addNumber} alt="7" >7</button></div>
                    <div className="keypad_button"><button className="btn-number" value="8" onClick={this.addNumber} alt="8" >8</button></div>
                    <div className="keypad_button"><button className="btn-number" value="9" onClick={this.addNumber} alt="9" >9</button></div>
                    <div className="keypad_button"><button className="btn-number" value="4" onClick={this.addNumber} alt="4" >4</button></div>
                    <div className="keypad_button"><button className="btn-number" value="5" onClick={this.addNumber} alt="5" >5</button></div>
                    <div className="keypad_button"><button className="btn-number" value="6" onClick={this.addNumber} alt="6" >6</button></div>
                    <div className="keypad_button"><button className="btn-number" value="1" onClick={this.addNumber} alt="1" >1</button></div>
                    <div className="keypad_button"><button className="btn-number" value="2" onClick={this.addNumber} alt="2" >2</button></div>
                    <div className="keypad_button"><button className="btn-number" value="3" onClick={this.addNumber} alt="3" >3</button></div>
                    <div className="keypad_button"><button className="btn-number" value="." onClick={this.addNumber} alt="." >.</button></div>
                    <div className="keypad_button"><button className="btn-number" value="0" onClick={this.addNumber} alt="0" >0</button></div>
                    <div className="keypad_button"><button className="btn-number" value="," onClick={this.addNumber} alt="," >,</button></div>

                </div>
                {/*<table><tbody>*/}
                {/*    <tr>*/}
                {/*        <td><button className="btn-number" value="7" onClick={this.addNumber} alt="7" >7</button></td>*/}
                {/*        <td><button className="btn-number" value="8" onClick={this.addNumber} alt="8" >8</button></td>*/}
                {/*        <td><button className="btn-number" value="9" onClick={this.addNumber} alt="9" >9</button></td>*/}
                {/*    </tr>*/}
                {/*    <tr>*/}
                {/*        <td><button className="btn-number" value="4" onClick={this.addNumber} alt="4" >4</button></td>*/}
                {/*        <td><button className="btn-number" value="5" onClick={this.addNumber} alt="5" >5</button></td>*/}
                {/*        <td><button className="btn-number" value="6" onClick={this.addNumber} alt="6" >6</button></td>*/}
                {/*    </tr>*/}
                {/*    <tr>*/}
                {/*        <td><button className="btn-number" value="1" onClick={this.addNumber} alt="1" >1</button></td>*/}
                {/*        <td><button className="btn-number" value="2" onClick={this.addNumber} alt="2" >2</button></td>*/}
                {/*        <td><button className="btn-number" value="3" onClick={this.addNumber} alt="3" >3</button></td>*/}
                {/*    </tr>*/}
                {/*    <tr>*/}
                {/*        <td><button className="btn-number" value="." onClick={this.addNumber} alt="." >.</button></td>*/}
                {/*        <td><button className="btn-number" value="0" onClick={this.addNumber} alt="0" >0</button></td>*/}
                {/*        <td><button className="btn-number" value="," onClick={this.addNumber} alt="," >,</button></td>*/}
                {/*    </tr>*/}
                {/*</tbody></table>*/}
            </div>
        );
    }
}

export class VotingSilencePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userID: userCookies.get('userID') || "NOT SET",
            noise: "quiet"
        };
        this.makeNoise = this.makeNoise.bind(this);
    }

    getUserId() {
        if (this.state.userID === "NOT SET") {
            const newUserId = this.makeId(12);
            this.setState({
                userID: newUserId
            });
            userCookies.set('userID', newUserId);
        }
        return this.state.userID;
    }

    makeId(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }

    makeNoise() {
        this.setState({ noise: "loud" });
        fetch('api/Vote', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "pollId": this.props.activePollId,
                "userId": this.state.userID,
                "vote": "A"
            })
        })
    }

    render() {
        return (
            <div className="quiet-page">
                <h1>Stay Quiet</h1>
               <button className="btn btn-noise" onClick={this.makeNoise}>Don't Press</button>
                <p className={(this.state.noise === "quiet" ? "hide" : "ominous-text")}>What is done cannot be undone...</p>
            </div>
        );
    }
}
